/**
 * CODE
 */

/**
 * I am a text highlighter.
 *
 * :param text: text to be highlighted
 * :param term: search term
 * :param index: term index
 *
 * :returns: highlighted text
 */
const highlight = (text: string, term: string, index?: number): string =>
{
    // get string index of term
    let termIndex = index;

    // term index not specified: get index of term
    if (termIndex === undefined)
    {
        termIndex = text.indexOf(term);
    }

    // get term length
    const termLength = term.length;

    // get text before search term
    let highlighted = text.substring(0, termIndex);

    // highlight term
    highlighted += (
        `<mark>${text.substring(termIndex, termIndex + termLength)}</mark>`
    );

    // append text to highlighted search term
    highlighted += text.substring(termIndex + termLength);

    // return highlighted text
    return highlighted;
};


/**
 * EXPORTS
 */
export default highlight;
